import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { TbaRangeType, DefineRangeTypePayload, EditRangeTypePayload } from '../models';

@Injectable()
export class RangeTypesService extends BaseService<TbaRangeType> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public listRangeTypes(tbaId: number): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}tba/${tbaId}`);
  }

  public getStatisticalMethods(): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}statistical-methods`);
  }

  public saveStatisticalMethod(data: DefineRangeTypePayload): Observable<any> {
    return this.http.post<any>(`${this.getResourceUrl()}`, data);
  }

  public editStatisticalMethod(rangeTypeId: number, data: EditRangeTypePayload): Observable<any> {
    return this.http.patch<any>(`${this.getResourceUrl()}${rangeTypeId}`, data);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}range-types/`;
  }
}
